<template>
    <OperationsDashboard></OperationsDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

const OperationsDashboard = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/OperationsDashboard/Table.vue")
);

export default {
    name: "Project_OperationDashboard",
    components: { OperationsDashboard, AuthLayout },
};
</script>
